import {Injectable} from '@angular/core';
import {LandingPageTile} from '../shared/tiles/home-tile.model';
import {availableTiles} from '../shared/tiles/tile-config';
import {HttpClient} from '@angular/common/http';
import {LandingPageConfig} from './landing-controller/landing-config.model';
import {AbstractCrudService} from '../shared/abstract-crud.service';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LandingPageService extends AbstractCrudService<LandingPageConfig> {

  public dashboard: Array<LandingPageTile> = [];
  public availableTiles: Array<LandingPageTile> = availableTiles;

  /**
   * URL for current model
   * @type {string}
   */
  protected url = environment.regoApiURL + 'landingconfig';

  constructor(http: HttpClient) {
    super(http);
  }

  public removeTile($event, item: LandingPageTile): void {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    this.dashboard.splice(this.dashboard.indexOf(item), 1);
  }

  public isTileVisible(itemId: string): boolean {
    // console.log(this.dashboard);
    return this.dashboard.find(o => {
      return o.panel === itemId;
    }) !== undefined;
  }

  public toggleTileVisible(item: LandingPageTile): void {
    if (!this.isTileVisible(item.panel)) {
      this.dashboard.push(item);
    } else {
      this.removeTile(null, item);
    }
  }

  public revertToDefault() {
    this.dashboard = [
      // this.getPanelById('DashboardComponent'),
      this.getPanelById('notification'),
      // this.getPanelById('dashboard'),
      this.getPanelById('scheduled-trains'),
      this.getPanelById('train-list'),
    ];
  }

  public getPanelById(id: string): LandingPageTile {
    return this.availableTiles.find(o => {
      return o.panel === id;
    });
  }
}
